var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { v4 as uuidV4 } from "uuid";
import { getCookie, removeCookies, setCookie } from "../cookie";
import dispatchUlmProfileEvent from "./dispatchUlmProfileEvent";
import psl from "./psl";
export default function refreshSession(config) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var client, expiry, sessionApi, ulmUuid, domain, accessToken, refreshToken, uuidCookie, ulmProfileEventParams, response, data, _b, ulmProfile, _c, ulmProfileToken, e_1, response, data, ulmResponse, ulmProfile, _d, ulmProfileToken, e_2;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    client = config.client, expiry = config.expiry, sessionApi = config.sessionApi;
                    ulmUuid = getCookie("acm_ulm_uuid");
                    domain = "." + (psl(window.location.hostname) || window.location.hostname);
                    accessToken = getCookie("acm_ulm_access_token");
                    refreshToken = getCookie("acm_ulm_refresh_token");
                    if (ulmUuid) {
                        uuidCookie = ulmUuid;
                    }
                    else {
                        uuidCookie = uuidV4();
                        setCookie("acm_ulm_uuid", uuidCookie, expiry.refreshSession || 3600, false, domain, true);
                    }
                    ulmProfileEventParams = null;
                    if (!(accessToken && sessionApi.getUser)) return [3 /*break*/, 6];
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(sessionApi.getUser, {
                            method: "POST",
                            headers: {
                                Authorization: accessToken,
                            },
                        })];
                case 2:
                    response = _e.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = (_e.sent());
                    setCookie("acm_ulm_payload", "acm", expiry.refreshSession, false, domain, true);
                    _b = data.response, ulmProfile = _b.ulm, _c = _b.ulmProfileToken, ulmProfileToken = _c === void 0 ? "" : _c;
                    ulmProfileEventParams = __assign(__assign({}, ulmProfile), { ulmProfileToken: ulmProfileToken });
                    dispatchUlmProfileEvent(ulmProfileEventParams);
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _e.sent();
                    console.error(e_1);
                    removeCookies([
                        { name: "acm_ulm_access_token", domain: domain },
                        { name: "acm_ulm_payload", domain: domain },
                        { name: "acm_ulm_uuid", domain: domain },
                        { name: "AstroUlmEPUID", domain: domain },
                    ]);
                    dispatchUlmProfileEvent();
                    return [3 /*break*/, 5];
                case 5: return [3 /*break*/, 13];
                case 6:
                    if (!(refreshToken && sessionApi.refresh)) return [3 /*break*/, 12];
                    _e.label = 7;
                case 7:
                    _e.trys.push([7, 10, , 11]);
                    return [4 /*yield*/, fetch(sessionApi.refresh, {
                            method: "POST",
                            headers: {
                                Authorization: refreshToken,
                                Client: client,
                                "Device-Id": uuidCookie,
                                "Content-Type": "application/json",
                                "Ulm-Redirect-Uri": document.location.href,
                            },
                        })];
                case 8:
                    response = _e.sent();
                    return [4 /*yield*/, response.json()];
                case 9:
                    data = (_e.sent());
                    ulmResponse = data.response;
                    setCookie("acm_ulm_access_token", (_a = ulmResponse.token) !== null && _a !== void 0 ? _a : "", expiry.startSession, false, domain, true);
                    setCookie("acm_ulm_payload", "acm", expiry.refreshSession, false, domain, true);
                    ulmProfile = ulmResponse.ulm, _d = ulmResponse.ulmProfileToken, ulmProfileToken = _d === void 0 ? "" : _d;
                    ulmProfileEventParams = __assign(__assign({}, ulmProfile), { ulmProfileToken: ulmProfileToken });
                    dispatchUlmProfileEvent(ulmProfileEventParams);
                    return [3 /*break*/, 11];
                case 10:
                    e_2 = _e.sent();
                    console.error(e_2);
                    removeCookies([
                        { name: "acm_ulm_access_token", domain: domain },
                        { name: "acm_ulm_refresh_token", domain: domain },
                        { name: "acm_ulm_payload", domain: domain },
                        { name: "acm_ulm_uuid", domain: domain },
                        { name: "AstroUlmEPUID", domain: domain },
                    ]);
                    dispatchUlmProfileEvent();
                    return [3 /*break*/, 11];
                case 11: return [3 /*break*/, 13];
                case 12:
                    removeCookies([
                        { name: "acm_ulm_payload", domain: domain },
                        { name: "acm_ulm_uuid", domain: domain },
                        { name: "AstroUlmEPUID", domain: domain },
                    ]);
                    dispatchUlmProfileEvent();
                    _e.label = 13;
                case 13: return [2 /*return*/, ulmProfileEventParams];
            }
        });
    });
}
